import React, { Component } from 'react';
import Header from './components/Layout/Header';
import Nav from './components/Layout/Nav';
import Footer from './components/Layout/Footer';
import firebase from 'firebase';

import config from './config';

import './App.css';

firebase.initializeApp(config);

class App extends Component {
  constructor () {
    super();
    this.state = {
      user:null
    }
  }

  componentWillMount () {
    firebase.auth().onAuthStateChanged(user => {
      this.setState({
        user
      })
    })
  }

  render() {
    let children = React.cloneElement(this.props.children, {user: this.state.user})
    return (
      <div className="App">
        <Header />
        <Nav user={this.state.user} />
        <div id="main-container" className="container">
          {children}
        </div>
        <Footer user={this.state.user} />
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/